import { AppointmentUnavailableModelBase } from "./AppointmentUnavailableModel.base"


/* A graphql query fragment builders for AppointmentUnavailableModel */
export { selectFromAppointmentUnavailable, appointmentUnavailableModelPrimitives, AppointmentUnavailableModelSelector } from "./AppointmentUnavailableModel.base"

/**
 * AppointmentUnavailableModel
 */
export const AppointmentUnavailableModel = AppointmentUnavailableModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
